// extracted by mini-css-extract-plugin
module.exports = {"base":"photo-story-card-m__base__2j-_w","card-content":"photo-story-card-m__card-content__1zLv9"};